import React, { useState } from 'react';
import styles from './EmailSignup.module.css';

const EmailSignup = () => {
  const [email, setEmail] = useState('');
  const [submitted, setSubmitted] = useState(false);

  const handleSubmit = (e) => {
    e.preventDefault();
    if (email) {
      // TODO: Connect to backend API
      console.log('Email submitted:', email);
      setSubmitted(true);
      setEmail('');
      setTimeout(() => setSubmitted(false), 3000);
    }
  };

  return (
    <section id="contact" className={styles["email-signup"]}>
      <div className={styles["email-signup-container"]}>
        <div className={styles["email-signup-content"]}>
          <h2 className={styles["email-signup-title"]}>
            The product will be available next month. don't miss the first batch if you are interested
          </h2>
          <p className={styles["email-signup-subtitle"]}>
            We will inform you as long as it's out, and you'll get a $15 cheaper earlybird price.
          </p>
          
          {submitted ? (
            <div className={styles["success-message"]}>
              <span className={styles["success-icon"]}>✓</span>
              <span>Thank you! We'll notify you when we launch.</span>
            </div>
          ) : (
            <form className={styles["email-form"]} onSubmit={handleSubmit}>
              <input
                type="email"
                className={styles["email-input"]}
                placeholder="Enter your email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                required
              />
              <button type="submit" className={styles["submit-button"]}>
                Submit
              </button>
            </form>
          )}
          
          <p className={styles["privacy-note"]}>
            We won't send you spam, you can unsubscribe at any time.
          </p>
        </div>
      </div>
    </section>
  );
};

export default EmailSignup;

